import ContactSection from "../../Components/ContactSection/ContactSection";

const Contact = () => {
  return <ContactSection />;
};
export default Contact;
